import {
  agEndDateCol,
  agPriceCol,
  agStartDateCol,
  agStatusCol,
  agDetailCol,
  agDepartmentsCol,
  agSelectCol
} from '@/ag-grid/ag-columns'
import { formatPrice } from '@lib/formatting.utils'

export default {
  computed: {
    options() {
      return {
        columnDefs: [
          agSelectCol({ vuexModule: 'renewal-proposal' }),

          agStatusCol(),

          {
            headerName: 'SUBSCRIPTION',
            field: 'name',
            type: ['textFilterColumn'],
            cellRendererFramework: 'LinkRenderer',
            cellRendererParams: params => {
              return {
                route: `/subscriptions/${params.data.subscription.id}`
              }
            }
          },

          {
            headerName: 'PUBLISHER',
            field: 'publisher.name',
            type: ['textFilterColumn']
          },

          {
            headerName: 'VENDOR',
            field: 'vendor.name',
            tooltipValueGetter: params => params.value || 'N/A',
            cellRenderer: params => params.value || 'N/A',
            type: ['textFilterColumn']
          },

          agDepartmentsCol('renewal-proposal', {
            headerName: this.departmentLabel.singular
          }),

          agStartDateCol(),

          agEndDateCol(),

          agDetailCol(),

          agPriceCol('USAGE', 'usage_from_two_periods_ago', { cellRenderer: params => params.value ?? 'N/A' }),

          agPriceCol('CPU', 'forecasted_cost_per_use_from_two_periods_ago_original_currency', {
            cellRenderer: params => params.value || 'N/A'
          }),

          agPriceCol('FORECASTED PRICE', 'forecasted_price'),

          agPriceCol('PRICE', 'price'),

          agPriceCol('Department share %', 'department_share_percentage', {
            cellRenderer: params => {
              if (params.value === null) return 'N/A'
              return `${formatPrice(params.value)} %`
            },
            hide: true
          }),

          agPriceCol(`${this.departmentLabel.singular} cost (original currency)`, 'department_cost', { hide: true }),

          {
            headerName: 'RECOMMENDATIONS',
            field: 'recommendation_status.name',
            type: 'centerAligned',
            cellRenderer: params => params.value.charAt(0).toUpperCase() + params.value.slice(1),
            filter: 'CustomFilter',
            floatingFilterComponentFramework: 'DropdownFilter',
            filterParams: {
              multiple: true,
              filterType: 'list_names',
              type: 'contains',
              optionsModule: 'renewal-proposal',
              optionsState: 'recommendationStatuses',
              filterInProgressModule: 'renewal-proposal',
              filterInProgressState: 'filterInProgress',
              optionsHandler: options => {
                const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1)
                return options.map(o => ({ label: capitalize(o.name), value: o.name }))
              }
            }
          },

          {
            headerName: 'RENEWAL PROPOSAL',
            minWidth: 256,
            width: 256,
            maxWidth: 256,
            pinned: 'right',
            sortable: false,
            filter: 'CustomFilter',
            type: ['centerAligned'],
            floatingFilterComponentFramework: 'StatusesFilter',
            filterParams: {
              vuexModule: 'renewal-proposal',
              vuexState: 'statuses'
            },
            field: 'proposal_status.name',
            cellRendererFramework: 'StatusesEditor',
            cellRendererParams: params => {
              return {
                vuexModule: 'renewal-proposal',
                vuexState: 'statuses',
                disable: params.data.status.name !== 'pending'
              }
            }
          }
        ],

        defaultColDef: {
          floatingFilter: true
        },

        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
